import { StyleSheet } from "react-native";
import { theme } from "../../theme";
const buttonColorCombinations = {
    brand: {
        text: "light",
        main: "base",
        hover: "dark",
        disabled: "lightest",
    },
    accent: {
        text: "dark",
        main: "base",
        hover: "darker",
        disabled: "lightest",
    },
    warning: {
        text: "dark",
        main: "base",
        hover: "darker",
        disabled: "lightest",
    },
    negative: {
        text: "light",
        main: "base",
        hover: "dark",
        disabled: "lightest",
    },
    usp: {
        text: "light",
        main: "base",
        hover: "dark",
        disabled: "lightest",
    },
    greyscale: {
        text: "light",
        main: "dark",
        hover: "darkest",
        disabled: "light",
    },
    positive: {
        text: "light",
        main: "dark",
        hover: "darkest",
        disabled: "light",
    },
};
/**
 * Styles for default fill variant, generated from above combinations
 */
export const styles = StyleSheet.create({
    ...Object.assign({}, ...Object.entries(buttonColorCombinations).map((input) => {
        // Casting required due to limited inference on Object.entries()
        const [accessor, colors] = input;
        return {
            [accessor]: {
                color: theme.colors[colors.text].base,
                borderColor: theme.colors[accessor][colors.main],
                backgroundColor: theme.colors[accessor][colors.main],
            },
        };
    })),
    light: {
        color: theme.colors.dark.base,
        borderColor: theme.colors.light.base,
        backgroundColor: theme.colors.light.base,
    },
    defaultStyle: {
        borderWidth: 2,
        alignItems: "center",
        borderStyle: "solid",
    },
    buttonText: {
        ...theme.fontDefaults.large,
        color: theme.colors.light.base,
        fontWeight: "600",
        textAlign: "center",
    },
    disabled: {
        backgroundColor: "red",
        opacity: 0.5,
    },
});
/**
 * Styles for outline variant, generated from above combinations
 */
export const outlineStyles = StyleSheet.create({
    ...Object.assign({}, ...Object.entries(buttonColorCombinations).map((input) => {
        // Casting required due to limited inference on Object.entries()
        const [accessor, colors] = input;
        return {
            [accessor]: {
                color: theme.colors.dark.base,
                borderColor: theme.colors[accessor][colors.main],
                backgroundColor: "transparent",
            },
        };
    })),
    light: {
        color: theme.colors.light.base,
        borderColor: theme.colors.light.base,
        backgroundColor: "transparent",
    },
});
export const sizeStyles = StyleSheet.create({
    small: {
        minWidth: 100,
        paddingHorizontal: theme.spacing.small,
        paddingVertical: 9,
        borderRadius: theme.spacing.medium,
    },
    medium: {
        minWidth: 120,
        padding: theme.spacing.small,
        borderRadius: theme.spacing.large,
    },
    large: {
        minWidth: 170,
        padding: theme.spacing.medium,
        borderRadius: theme.spacing.xlarge,
    },
});
export const sizeTextStyles = StyleSheet.create({
    small: theme.fontDefaults.xsmall,
    medium: theme.fontDefaults.xsmall,
    large: theme.fontDefaults.base,
});
//# sourceMappingURL=Button.styles.js.map